module.exports = __webpack_public_path__ + "img/ico-arrow-left.629459b9.svg";